<template>
  <b-modal id="createUmfrageModal" title="Erstelle eine neue Umfrage" centered @hide="onHide">
    <b-form-group label="Team">
      <AppSelect
        v-model="teamSelected"
        :options="teamOptions"
        label="Team"
        placeholder="Wähle Team aus..."
        clearable
      />
    </b-form-group>
    <b-form-group label="Überschrift">
      <b-form-input v-model="ueberschrift"></b-form-input>
    </b-form-group>
    <b-form-group label="Seite">
      <AppSelect
        v-model="pageSelected"
        sort="none"
        :options="pageOptions"
        label="Seite"
        placeholder="Wähle die Seite aus, auf der die Umfrage erscheinen soll"
        multiple
      />
    </b-form-group>
    <template #modal-footer="{ hide }" class="pl-1">
      <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
      <b-button
        class="dialog-btn"
        :disabled="disableSichernButton"
        variant="primary"
        @click="createUmfrage(hide)"
      >
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapState } from 'vuex';
import AppSelect from '@/components/common/app-select/app-select.vue';
import { CREATE_UMFRAGE, GET_UMFRAGEN } from '../../core/umfragen/umfragen.module';

export default {
  components: {
    AppSelect,
  },
  data() {
    return {
      teamSelected: null,
      ueberschrift: null,
      pageSelected: [],
    };
  },
  computed: {
    ...mapState({
      users: state => state.users.users,
    }),
    disableSichernButton() {
      return this.teamSelected == null || this.pageSelected.length === 0;
    },
    teamOptions() {
      const duplicateDepartments = this.users
        .filter(({ givenName }) => givenName !== null && !givenName.toLowerCase().includes('test'))
        .filter(({ surname }) => surname !== null && !surname.toLowerCase().includes('test'))
        .filter(({ mail }) => mail !== null)
        .map(({ department }) => department);
      return [...new Set(duplicateDepartments)]
        .filter(dep => dep !== null)
        .map(department => ({ value: department, text: department }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    pageOptions() {
      return [
        { value: 'all', text: 'Alle' },
        { value: 'aufgaben-overview', text: 'Aufgaben' },
        { value: 'reisen-overview', text: 'Reiseübersicht' },
        { value: 'reisetermine-overview', text: 'Reiseterminübersicht' },
        { value: 'pm-planung', text: 'Reiseterminplanung' },
        { value: 'flugplanung-planung', text: 'Flugplanung' },
        { value: 'flugstammdaten-view', text: 'Flugstammdaten' },
        { value: 'reisetermin-reisefinder', text: 'Reisefinder' },
        { value: 'fvc-overview', text: 'FVC Übersicht' },
        { value: 'zvc', text: 'ZVC' },
        { value: 'yield-controlling', text: 'Yield Controlling' },
        { value: 'flugbuchungen-controlling', text: 'Flugbuchungen Controlling' },
        { value: 'reisetermine-view', text: 'Reisetermindetailseite' },
        { value: 'reisetermin-view-releasepruefung', text: 'Releaseprüfung' },
        { value: 'dubletten-confirmation', text: 'Kunden Dublettenprüfung' },
        { value: 'katalog-reisen', text: 'Katalog' },
        { value: 'fit-reisen', text: 'FIT Reisen' },
      ].sort((a, b) => a.text.localeCompare(b.text));
    },
  },
  watch: {
    // watcher auf die Auswahl, damit diese bereinigt wird zb wenn man 2 Seiten auswählt und danach dann "Alle" wird nur noch "Alle" angezeigt
    pageSelected(newVal, oldVal) {
      if (!newVal || newVal.length === 0) return;

      const alleSeitenHinzugefuegt = newVal.includes('all');
      const alleSeitenAlsErstesHinzugefuegt = oldVal?.includes('all');

      if (alleSeitenHinzugefuegt && !alleSeitenAlsErstesHinzugefuegt) {
        this.pageSelected = newVal.filter(seite => seite === 'all');
      } else if (alleSeitenHinzugefuegt && alleSeitenAlsErstesHinzugefuegt && newVal.length > oldVal.length) {
        this.pageSelected = newVal.filter(seite => seite !== 'all');
      }
    },
  },
  methods: {
    createUmfrage(hide) {
      if (this.teamSelected != null) {
        const params = {
          team: this.teamSelected,
          ueberschrift: this.ueberschrift,
          pages: this.pageSelected,
        };
        console.log(params);
        this.$store.dispatch(CREATE_UMFRAGE, params).then(() => {
          hide();
          this.$store.dispatch(GET_UMFRAGEN);
          this.toast('Umfrage erfolgreich erstellt');
        });
      }
    },
    onHide() {
      this.teamSelected = null;
      this.ueberschrift = null;
      this.pageSelected = [];
    },
  },
};
</script>
<style scoped></style>
